import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {PhosphorIcon} from "@khanacademy/wonder-blocks-icon";
import {Strut} from "@khanacademy/wonder-blocks-layout";
import {
    border,
    color,
    font,
    semanticColor,
    spacing,
} from "@khanacademy/wonder-blocks-tokens";
import {HeadingSmall} from "@khanacademy/wonder-blocks-typography";

import arrowIcon from "@phosphor-icons/core/regular/arrow-bend-right-down.svg";

interface Props {
    cardWidth: number;
    cardHeight: number;
}

const PlaceholderQuestion: React.FC<Props> = (props) => {
    const dimensions = {
        width: props.cardWidth,
        height: props.cardHeight,
    };
    return (
        <View style={[dimensions, styles.placeholder]}>
            <PhosphorIcon
                size="medium"
                color={color.offBlack32}
                icon={arrowIcon}
            />
            <Strut size={spacing.medium_16} />
            <HeadingSmall style={styles.label}>
                {t`Add a question from Khanmigo's deck`}
            </HeadingSmall>
        </View>
    );
};
const styles = StyleSheet.create({
    placeholder: {
        backgroundColor: color.offBlack16,
        borderRadius: border.radius.radius_040,
        justifyContent: "center",
        alignItems: "center",
    },
    label: {
        width: 200,
        textAlign: "center",
        color: semanticColor.core.foreground.neutral.default,
        fontSize: font.size.medium,
        lineHeight: 1.2,
    },
});

export default PlaceholderQuestion;
